<template>
  <div v-if="editType" style="position: relative;">
    <DropZones style="border:none;height:100px;background: transparent;" @drop.prevent="drop" @change="selectedFile"
      :inputFileId="fileId" :uploadType="'image/gif,image/jpeg,image/jpg,image/png'"/>
    <!-- 删除图片按钮 -->
    <template v-if="fileCount > 0">
      <i class="bx bxs-x-circle" @click="delAllFiles"></i>
    </template>

  </div>
</template>

<script>
import Swal from "sweetalert2";
import DropZones from "@/components/widgets/dropZoneAttr.vue";
// import SwiperTool from "@/components/swiperTool.vue";
import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import { getUploadFileSign, getUploadFileDetail, postUpdateFile } from "@/service";
import { imageCompress } from '@/utils/common.js'
import _ from "lodash";
// import DropZone from "@/components/widgets/dropZoneAttr.vue";

export default {
  emits: ["update:filesNums", "update:files", "openAlert", "filesChanges"],
  props: {
    fileId: {
      type: String,
      default: () => {
        return ''
      }
    },
    editType: {
      type: Boolean,
      default: () => {
        return false
      }
    },

    setObj: {
      type: Object,
      default: () => {
        return {};
      },
    },
    faultEditableTabsValue: {
      type: String,
      default: () => {
        return ''
      }
    },
    files: {
      type: Object,
      default: () => {
        return { image: [], video: [], document: [] };
      },
    },
    filesNums: {
      type: Array,
      default: () => {
        return [];
      },
    },
    fileCount: {
      type: Number,
      default: 0,
    }
  },
  setup() { },
  data() {
    return {
      showfiles: { image: [], video: [], document: [] },
      fileMaxSize: 1024 * 1024 * 50,
      filesNum: [],
    };
  },
  components: {
    DropZones,
  },
  computed: {

  },
  watch: {


  },
  mounted() {
  },
  methods: {
    checkFile(file) {
      let name = /^device\//.test(file.name)
        ? file.name.substring(44)
        : file.name;
      let suffix = name.substring(name.lastIndexOf("."));
      let type = /\.(png|jpeg|jpg)$/.test(suffix)
        ? "image"
        : /\.(ppt|pptx|pdf|xls|xlsx|doc|docx)$/.test(suffix)
          ? "document"
          : "video";
      let i = this.showfiles[type].findIndex((item) => {
        let object_name = /^device\//.test(item.object_name)
          ? item.object_name.substring(44)
          : item.object_name;
        return object_name === name;
      });
      return i == -1;
    },
    async selectedFile() {
      let dropzoneFile = document.getElementById(this.fileId).files[0];

      console.log(dropzoneFile)
      if (!dropzoneFile) return;
      if (dropzoneFile.size > this.fileMaxSize) {
        this.$emit(
          "openAlert",
          {
            variant: "danger",
            content: this.$t('page.files_upload.file_size_cannot_exceed_50M'),
            icon: "ri-error-warning-line",
          },
          false
        );
        document.getElementById(this.fileId).value = "";
        return;
      }
      if (!this.checkFile(dropzoneFile)) {
        this.$emit(
          "openAlert",
          {
            variant: "danger",
            content: this.$t('page.files_upload.same_name_file'),
            icon: "ri-error-warning-line",
          },
          false
        );
        document.getElementById(this.fileId).value = "";
        return;
      }
      let suffix = dropzoneFile.name.substring(dropzoneFile.name.lastIndexOf("."));
      if (/\.(png|jpeg|jpg)$/.test(suffix)) {
        let file = await imageCompress(dropzoneFile)
        this.uploadFileSign(file);
      } else {
        this.uploadFileSign(dropzoneFile);
      }
    },
    async drop(e) {
      let dropzoneFile = e.dataTransfer.files[0];
      if (!dropzoneFile) return;
      if (dropzoneFile.size > this.fileMaxSize) {
        this.$emit(
          "openAlert",
          {
            variant: "danger",
            content: this.$t('page.files_upload.file_size_cannot_exceed_50M'),
            icon: "ri-error-warning-line",
          },
          false
        );
        document.getElementById(this.fileId).value = "";
        return;
      }

      if (!this.checkFile(dropzoneFile)) {
        this.$emit(
          "openAlert",
          {
            variant: "danger",
            content: this.$t('page.files_upload.same_name_file'),
            icon: "ri-error-warning-line",
          },
          false
        );
        document.getElementById(this.fileId).value = "";
        return;
      }
      let suffix = dropzoneFile.name.substring(dropzoneFile.name.lastIndexOf("."));
      if (/\.(png|jpeg|jpg)$/.test(suffix)) {
        let file = await imageCompress(dropzoneFile)
        this.uploadFileSign(file);
      } else {
        this.uploadFileSign(dropzoneFile);
      }
    },
    deleteFile(i, type) {
      Swal.fire(this.$t('base.delete_success'));
      this.showfiles[type].splice(i, 1);
    },
    // 删除所有附件
    delAllFiles() {
      this.$emit('filesChanges', {
        setObj: this.setObj,
        filesNum: [],
        setType: '2',
        delFiles: true // 删除所有附件
      })
    },
    uploadFileSign(file) {
      Swal.fire({ title: this.$t('page.files_upload.uploading'), showConfirmButton: false });
      Swal.showLoading();
      let filename = file.name;
      let objectName = `device/${uuidv4()}/${filename}`
      let params = {
        object: objectName,
        method: 'upload'
      };
      getUploadFileSign(params)
        .then((res) => {
          if (res && res.payload) {
            axios
              .put(
                res.payload.signedUrl,
                file,
                { headers: { "Content-Type": file.type } }
              )
              .then(() => {
                let params = {
                  object: objectName,
                };
                getUploadFileDetail(params).then((resDetail) => {
                  if (resDetail && resDetail.payload) {
                    let detail = resDetail.payload
                    let info = {
                      url: detail.url,
                      etag: detail.etag,
                      size: detail.size,
                      content_type: detail.contentType,
                      object_name: detail.objectName,
                      last_modified: detail.lastModified,
                    };

                    let suffix = info.object_name.substring(
                      info.object_name.lastIndexOf(".")
                    );
                    if (/\.(png|jpeg|jpg)$/.test(suffix)) {
                      this.showfiles["image"].push(info);
                    } else if (
                      /\.(ppt|pptx|pdf|xls|xlsx|doc|docx)$/.test(suffix)
                    ) {
                      this.showfiles["document"].push(info);
                    } else {
                      this.showfiles["video"].push(info);
                    }
                    document.getElementById(this.fileId).value = "";
                    postUpdateFile(info).then((post) => {
                      this.filesNum = []
                      if (post && post.payload) {
                        let file = _.cloneDeep(post.payload);
                        this.filesNum.push(file.id);
                        this.$emit('filesChanges', { setObj: this.setObj, filesNum: this.filesNum, setType: '2' })
                        setTimeout(() => {
                          this.formValidataAlert = false;
                        }, 3000);
                      }
                    });
                    Swal.close();
                    this.$emit(
                      "openAlert",
                      {
                        variant: "success",
                        content: this.$t('base.upload_success'),
                        icon: "ri-check-double-line",
                      },
                      false
                    );
                  }
                });
              })
              .catch(() => {
                Swal.close();
                this.$emit(
                  "openAlert",
                  {
                    variant: "danger",
                    content: this.$t('base.delete_failed_please_try_again'),
                    icon: "ri-error-warning-line",
                  },
                  false
                );
                document.getElementById(this.fileId).value = "";
              });
          }
        })
        .catch(() => {
          Swal.close();
          this.$emit(
            "openAlert",
            {
              variant: "danger",
              content: this.$t('base.delete_failed_please_try_again'),
              icon: "ri-error-warning-line",
            },
            false
          );
          document.getElementById(this.fileId).value = "";
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.material-title {
  border-left: 3px solid;
  padding-left: 8px;
  height: 22px;
  line-height: 22px;
}

.bxs-x-circle {
  position: absolute;
  top: -10px;
  right: -10px;
  font-size: 30px;
  opacity: 0.1;
  z-index: 3;
  transition: all ease 0.2s;
  cursor: pointer;

  &:hover {
    opacity: 1;
  }
}
</style>
